<script setup lang="ts">
import { nav } from '@/data/megaMenuData'
const i18nService = usei18nService()
const localePath = useLocalePath()
const route = useRoute()
const { locale } = useI18n()

const { isMobile_lg, isTablet_lg } = useWindowWidth()

const isCurrentRoute = (to: string) => {
	if (to === route.name?.slice(0, -5)) return true
	return false
}

const redirectionLink = (to: string) => {
	if (to === 'news-page') return '/pl/aktualnosci'
	return localePath(to)
}

const computedNav = computed(() => {
	return nav
		.map((item) => {
			if (item.translation_key_label === 'frequent_questions') {
				return { ...item, to: `https://intercom-help.eu/carfree/${locale.value === 'en' ? 'en' : 'pl'}/` }
			}
			if (item.translation_key_label === 'app') {
				return { ...item, to: `https://aplikacja.carfree.pl/${locale.value === 'pl' ? '' : 'en/home'}` }
			}
			return item
		})
		?.filter((item) => (item?.showOnlyOnPL ? locale.value === 'pl' : true))
})
</script>

<template>
	<nav class="nav">
		<NuxtLink class="nav__logo" :prefetch="false" :to="localePath('/')">
			<GlobalIcon
				name="carfree-logo"
				alt="Logo strony Carfree wypożyczalnia samochodów"
				:width="isMobile_lg ? 74 : 94"
				:height="isMobile_lg ? 32 : 46" />
		</NuxtLink>
		<template v-for="(item, index) in computedNav" :key="index">
			<NuxtLink
				v-if="item.type === 'link'"
				:to="item.newTab === true ? item.to : redirectionLink(item.to)"
				class="nav__item"
				:rel="item.rel ? item.rel : undefined"
				:prefetch="false"
				:class="{ 'nav__item--active': isCurrentRoute(item.to) }"
				:target="item.newTab === true ? '_blank' : ''"
				>{{ i18nService.$tDynamic('components.nav', item.translation_key_label || item.label) }}</NuxtLink
			>
			<LazyVisibleGlobalMegaMenu v-else-if="!isTablet_lg" :item="item" hydrate-on-visible />
		</template>
	</nav>
</template>

<style lang="scss">
@import './Nav';
</style>
